import { toRaw } from "vue";

type GridRow = Record<string, unknown>;

/** Matched by `trackBy` when both rows carry one, so a selection survives a re-query (fresh row objects). */
export function isSameGridRow(a: GridRow, b: GridRow, trackBy: string | undefined): boolean {
  const left = toRaw(a);
  const right = toRaw(b);
  // A null key names no row; `0` is still a key.
  if (trackBy && left?.[trackBy] != null && right?.[trackBy] != null) return left[trackBy] === right[trackBy];
  return JSON.stringify(left) === JSON.stringify(right);
}

export function isGridRowChecked(
  row: GridRow,
  selection: { selectAll: boolean; selectedItems: GridRow[]; excludedItems: GridRow[] },
  trackBy: string | undefined,
): boolean {
  return (
    (selection.selectAll && !selection.excludedItems.some((el) => isSameGridRow(el, row, trackBy))) ||
    selection.selectedItems.some((el) => isSameGridRow(el, row, trackBy))
  );
}
